exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_object-gops.js
// module id = 506
// module chunks = 1